var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubstepGeolocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 884.59563,
    height: 579.04269,
    viewBox: "0 0 884.59563 579.04269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location_tracking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 139.17081,
    width: 516.59563,
    height: 330.84626,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 175.80851,
    width: 419.78714,
    height: 257.57085,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 225.27377,
    width: 419.78714,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 302.59072,
    width: 419.78714,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 474.84005,
    y: 260.41784,
    width: 177.47754,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 384.30068,
    width: 419.78714,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 466.93263,
    y: 175.80851,
    width: 15.81483,
    height: 218.15679,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 762.14281,
    y: 175.80851,
    width: 15.81483,
    height: 135.56823,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 642.65297,
    y: 175.80851,
    width: 15.81483,
    height: 257.57085,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 552.157,
    y: 305.22653,
    width: 15.81483,
    height: 128.15283,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 650.56039,
    cy: 310.49814,
    r: 20.20784,
    fill: "#00a42b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M810.01978,110.47866a76.40751,76.40751,0,0,0-76.4075,76.4075c0,42.19868,76.4075,201.93411,76.4075,201.93411s76.4075-159.73543,76.4075-201.93411A76.40751,76.40751,0,0,0,810.01978,110.47866Zm0,112.792a36.38453,36.38453,0,1,1,36.38453-36.38452A36.38454,36.38454,0,0,1,810.01978,223.27068Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#00a42b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstepGeolocation);
export default __webpack_public_path__ + "static/media/substep_geolocation.5823e6cc38b2a37802f6c80f2ddf9707.svg";
export { ForwardRef as ReactComponent };